const WISHLIST_STORAGE_KEY = 'velyve:wishlist';
const WISHLIST_UPDATED_EVENT = 'velyve:wishlist-updated';

function getWishlist() {
  try {
    const raw = localStorage.getItem(WISHLIST_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function setWishlist(handles) {
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(handles));
  window.dispatchEvent(new CustomEvent(WISHLIST_UPDATED_EVENT));
}

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.productHandle;
    this.button = this.querySelector('button');
    if (!this.handle || !this.button) return;

    this.updateState();
    this.button.addEventListener('click', () => this.toggle());
    this.onWishlistUpdated = () => this.updateState();
    window.addEventListener(WISHLIST_UPDATED_EVENT, this.onWishlistUpdated);
  }

  disconnectedCallback() {
    window.removeEventListener(WISHLIST_UPDATED_EVENT, this.onWishlistUpdated);
  }

  isSaved() {
    return getWishlist().includes(this.handle);
  }

  toggle() {
    const list = getWishlist();
    const index = list.indexOf(this.handle);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(this.handle);
    }
    setWishlist(list);
    this.updateState();
  }

  updateState() {
    const saved = this.isSaved();
    this.button.setAttribute('aria-pressed', String(saved));
    this.classList.toggle('wishlist-button--active', saved);
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}

async function renderWishlistPage() {
  const container = document.querySelector('[data-wishlist-grid]');
  if (!container) return;

  const emptyState = document.querySelector('[data-wishlist-empty]');
  const handles = getWishlist();

  container.innerHTML = '';

  if (!handles.length) {
    if (emptyState) emptyState.hidden = false;
    return;
  }
  if (emptyState) emptyState.hidden = true;

  const products = await Promise.all(
    handles.map((handle) =>
      fetch(`/products/${handle}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null)
    )
  );

  const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : undefined;

  products
    .filter(Boolean)
    .forEach((product) => {
      const price = (product.price / 100).toLocaleString(document.documentElement.lang || undefined, {
        style: 'currency',
        currency,
      });

      const card = document.createElement('div');
      card.className = 'wishlist-page__card';
      card.innerHTML = `
        <a href="${product.url}" class="wishlist-page__image-wrapper">
          <img src="${product.featured_image}" alt="${product.title}" loading="lazy" width="600" height="750">
        </a>
        <div class="wishlist-page__details">
          <a href="${product.url}" class="wishlist-page__title">${product.title}</a>
          <p class="wishlist-page__price">${price}</p>
        </div>
      `;

      const removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'wishlist-page__remove button-unstyled';
      removeButton.textContent = '×';
      removeButton.setAttribute('aria-label', 'Remove from wishlist');
      removeButton.addEventListener('click', () => {
        setWishlist(getWishlist().filter((h) => h !== product.handle));
      });

      card.appendChild(removeButton);
      container.appendChild(card);
    });
}

document.addEventListener('DOMContentLoaded', renderWishlistPage);
window.addEventListener(WISHLIST_UPDATED_EVENT, renderWishlistPage);
